import Glide from '@glidejs/glide';

import BaseUI from '../../../../component/baseui';
import sliderItemTpl from './slider-item.html';
import slideUpTpl from './slide-up.html';
import util from '../../../../lib/util.js';

import './style.scss';
import { getTranslation } from '../../../../utils';

const clickType = util.click();
const LOG_C = 'returnAndRefund';
let app = null;
// let isLoading = false;
// let isEnded = false;
// let packages = [];
let orders = [];
let items = [];

/**
 * 展示知识点评价
 */
// function showRate(data, FEEDBACK) {
//   app.appendMessage({
//     type: 'feedback',
//     body: Object.assign({}, FEEDBACK, { chatUuid: data.chatUuid }),
//   });
// }

function onSlideDownListener($node) {
  app.log.send({
    c: LOG_C,
    d: 'hide',
  });
  $node.find('.J_Mask').hide().parent().addClass('slide-out-to-bottom');
  const timer = setTimeout(() => {
    $node.hide();
    if (timer) {
      clearTimeout(timer);
    }
  }, 500);
}

function onLoadDetailListener(e, $node) {
  const $item = $(e.currentTarget);
  const packageNo = $item.data('package-no');
  const itemIndex = $item.data('item-index');
  // const pack = orders.find(o => o.packages.find(p => (+p.ra_no === packageNo)));
  let pack;
  let order;
  for (let i = 0; i < orders.length; i++) {
    order = orders[i];
    const packs = order.packages;
    pack = packs.find(p => (+p.ra_no === packageNo));
    if (pack) break;
  }
  const item = pack.items[itemIndex - 1];
  const { requestType, reverseOrderId } = order.detailUrlParams;

  app.appendMessage({
    type: 'rarCard',
    body: {
      ...item,
      action: pack.button.action,
      url: app.param.returnDetailLink.split('?').shift().concat(`?requestType=${requestType}&reverseOrderId=${reverseOrderId}`),
    },
  });
  onSlideDownListener($node);
}

function bindClosePanel($node) {
  $node.find('.J_Toggle').off(clickType, () => onSlideDownListener($node));
  $node.find('.J_Toggle').on(clickType, () => onSlideDownListener($node));
}

function bindLoadDetail($node) {
  $node.find('._item').off(clickType, e => onLoadDetailListener(e, $node));
  $node.find('._item').on(clickType, e => onLoadDetailListener(e, $node));
}

function bundSliderEvents(glider, $sliderNode) {
  $sliderNode.find('.btn-details').on(clickType, (e) => {
    const target = e.currentTarget;
    app.util.openWindow(target.dataset.url);
  });
  const $next = $sliderNode.find('.glide_next');
  const $prev = $sliderNode.find('.glide_prev');
  $next.on(clickType, () => glider.go('>'));
  $prev.on(clickType, () => glider.go('<'));
  glider.on(['move'], () => {
    if (glider.index === 0) {
      $prev.hide();
      $next.show();
    } else if (glider.index === (items.length - 1)) {
      $next.hide();
      $prev.show();
    } else {
      $prev.show();
      $next.show();
    }
  });
  $sliderNode.find('.btn-details').on(clickType, (e) => {
    e.stopPropagation();
    app.util.openWindow(e.currentTarget.dataset.url);
  });
}

function bindSlideUpEvents($node) {
  bindClosePanel($node);
  bindLoadDetail($node);
  // const loadMoreAction = data.action;
  // // Uncomment for release load more function
  // const $scroller = $node.find('.list-wrapper');
  // const onLoadMoreListener = (e) => {
  //   const container = e.target;
  //   const scrollTop = container.scrollTop;
  //   const scrollHeight = container.scrollHeight;
  //   const height = container.clientHeight;
  //   if (Math.ceil(scrollHeight - scrollTop) === height && !isLoading && !isEnded) {
  //     isLoading = true;
  //     $node.find('._loading').toggleClass('hidden');
  //     const timer = setTimeout(() => {
  //       isLoading = false;
  //       isEnded = true;
  //       $node.find('._loading').toggleClass('hidden');
  //       // orders = orders.concat(orders);
  //       // const newTpl = slideUpTpl.render({ orders });
  //       // container.replaceChild($(newTpl)[0], document.getElementById('J_SlideUp'));
  //       // bindSlideUpEvents($node);
        // this.view.footer.submit({
        //   q: 'feedback',
        //   ext: { botJson: JSON.stringify(loadMoreAction) }
        // }, 'text', false, true);
  //       clearTimeout(timer);
  //     }, 2000);
  //   }
  // };
  // $scroller.off('scroll', onLoadMoreListener);
  // $scroller.scroll(onLoadMoreListener);
}

export default function rarList(data) {
  app = this;
  orders = data.orders || [];
  items = data.items || [];
  let params;
  let isSlideUp = false;
  let $node;
  const ts = {
    refundAmountText: getTranslation('csc.bot.rar.refund_amount'),
    returnReasonText: getTranslation('csc.bot.rar.return_reason'),
    viewDetailText: getTranslation('csc.btn.view_detail'),
    loadingText: getTranslation('csc.btn.loading'),
    raNoText: getTranslation('csc.bot.rar.ra_no'),
    requestedOnText: getTranslation('csc.bot.rar.requested_on'),
  };

  switch (true) {
    case items.length <= 3 && items.length >= 1:
      const feedbackAction = orders[0].packages[0].button.action || {};
      const contents = items.map(item => sliderItemTpl.render({
        ...item,
        ...ts,
        url: app.param.returnDetailLink.split('?').shift().concat(`?${item.url}`),
      }));
      const sliderClass = 'rar-slider';
      params = {
        name: 'rar_slider',
        mid: data.mid,
        side: 'left',
        contents,
        message: getTranslation('csc.bot.rar.items_returned', { returnedLength: items.length }),
        sliderClass,
        showNavigator: util.isPC() && items.length > 1,
      };
      $node = $(BaseUI.slider(params));
      const timer = setTimeout(() => {
        const sliderNode = $node[2];
        const glider = new Glide(sliderNode, {
          type: 'slider',
          startAt: 0,
          perView: 1.5,
          rewind: false,
          focusAt: 'center',
        });
        bundSliderEvents(glider, $(sliderNode));
        glider.mount();
        clearTimeout(timer);
      }, 100);

      /**
       * 需要展示评价
       * 1、实时问答里needEval是true
       * 2、历史消息里有feedback（用户评价过）
       */
      // showRate(data, FEEDBACK);
      this.view.footer.submit({ q: 'feedback', ext: { botJson: JSON.stringify(feedbackAction) } }, 'text', false, true);
      break;
    case items.length > 3:
      isSlideUp = true;
      params = {
        name: 'rar_list',
        mid: data.mid,
        content: slideUpTpl.render({
          orders,
          ...ts,
        }),
        theme: 'question',
        title: getTranslation('csc.bot.rar.packages_returned'),
        isScrollable: true,
      };

      $node = $(BaseUI.slideUp(params));
      window.rarSlideUpNode = $node;
      bindSlideUpEvents($node, data);
      break;
    default:
      app.appendMessage({
        type: 'robot',
        body: {
          text: getTranslation('csc.bot.rar.items_empty'),
        },
      });
      break;
  }

  return {
    // 插件返回的结果
    body: $node,
    isSlideUp,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/rar/list/index.js